import { ref, computed } from 'vue'
import type { ComputedRef } from 'vue'
import { productSharingData } from '@/legacy/ts/productSharing'
import {
	instanceBuyandship,
	instanceProductSharing,
} from '@/assets/ts/apiManagement'

export default function useProductSharing() {
	const PSUsername = ref<string | null>(null)
	const PSUserAvatarSrc = ref<string | null>(null)
	const isUserVerified: ComputedRef<Boolean> = computed(
		() => window.BUYANDSHIP.settings.user_onboarded,
	)

	async function connectPS() {
		try {
			const { data } = await instanceBuyandship.post('connect/productsharing', {
				headers: {
					Cookie: document.cookie,
				},
			})
			if (data && data.token) {
				const date = new Date(+new Date())
				const timestamp = date.setTime(date.getTime() + 20 * 3600000)
				if (data && data.token) {
					localStorage.setItem(
						`tokenProductSharing_${productSharingData.userId}`,
						data.token,
					)
					instanceProductSharing.defaults.headers.Authorization = `Bearer ${data.token}`
					localStorage.setItem(
						`tokenProductSharing_${productSharingData.userId}_expired_time`,
						timestamp.toString(),
					)
				}
			}
		} catch (error) {
			console.log(error)
			throw error
		}
	}

	function setToken() {
		return new Promise(resolve => {
			const defaultCheck = productSharingData.userId && localStorage
			const tokenExpiredTime = Number(
				localStorage.getItem(
					`tokenProductSharing_${productSharingData.userId}_expired_time`,
				),
			)
			const isTokenExpired =
				defaultCheck &&
				(!tokenExpiredTime ||
					(tokenExpiredTime && +new Date() > tokenExpiredTime))
			if (
				defaultCheck &&
				!isTokenExpired &&
				localStorage.getItem(`tokenProductSharing_${productSharingData.userId}`)
			) {
				// do nothing
				resolve(true)
			} else {
				localStorage.removeItem(
					`tokenProductSharing_${productSharingData.userId}`,
				)
				localStorage.removeItem(
					`tokenProductSharing_${productSharingData.userId}_expired_time`,
				)
				connectPS().then(() => resolve(true))
			}
		})
	}

	function isHasPSProfile(): Promise<boolean> {
		return new Promise(resolve => {
			if (PSUsername.value) {
				resolve(true)
				return
			}
			if (!productSharingData.isLogin || !isUserVerified.value) {
				resolve(false)
				return
			}
			fetchPSUserProfile().then(userInfo => resolve(userInfo.username !== ''))
		})
	}

	function getPSUsername(): Promise<string> {
		return new Promise(resolve => {
			if (PSUsername.value) {
				resolve(PSUsername.value)
				return
			}
			if (!productSharingData.isLogin || !isUserVerified.value) {
				resolve('')
				return
			}
			fetchPSUserProfile().then(userInfo => resolve(userInfo.username))
		})
	}

	async function fetchPSUserProfile() {
		return instanceProductSharing
			.get('/users/me')
			.then(({ data: { data } }) => {
				if (!data) return ''
				PSUsername.value = data.username
				if (data && data.image && Object.keys(data.image).length)
					PSUserAvatarSrc.value = data.image[100]
				return data
			})
			.catch(err => {
				if (err.response && err.response.status === 401) {
					connectPS()
						.then(() => fetchPSUserProfile())
						.catch(() => {})
				}
			})
	}

	return {
		PSUsername,
		PSUserAvatarSrc,
		isUserVerified,
		connectPS,
		setToken,
		isHasPSProfile,
		getPSUsername,
		fetchPSUserProfile,
	}
}
